import { generateId } from '@ai-sdk/provider-utils';
import type { SupabaseChangeData } from '~/lib/stores/supabase';
import type { SupabaseDBChangeMessage } from '~/types/chat';

export function fromDBConfirmationInfoToChatMessage(change: SupabaseChangeData): SupabaseDBChangeMessage {
  return {
    role: 'user',
    type: 'supabase',
    change,
    changeStatus: 'pending',
    content: '',
    id: generateId(),
    ignore: true,
    status: 'complete',
    parts: [],
  };
}
